import '@/assets/css/reset.scss';
import '@/assets/css/element.scss';
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';

import VueNeditorWrap from 'vue-neditor-wrap'

Vue.component('VueNeditorWrap', VueNeditorWrap)

import help from '@/util/help';
import api from '@/util/api';
import variable from '@/util/variable';
import storeBase from '@/util/store';
import '@/util/commonImport';


Vue.use(Vuex);

Vue.prototype.$api = api;
Vue.prototype.$variable = variable;
Vue.prototype.$help = help;

// 加载按钮权限filter
function auth(key) {
    if (key) {
        return !storeBase.state.btnRights[key]
    } else {
        return false
    }
}
Vue.prototype.auth = auth
Vue.filter('auth', auth)

export default new Vue({
    store: new Vuex.Store(storeBase),
    render: h => h(App),
}).$mount('#app')
